import Vue from 'vue'
import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { Property } from '@/modules/Property/interfaces/property'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

import PropertyForm from '@/modules/Property/components/PropertyForm.vue'
import { deleteProperty } from '@/modules/Property/gql/property.gql'

@Component({
  components: {
    PropertyForm,
    AppDialog
  }
})
export default class PropertyDialog extends Vue {
  targetProperty: Property | null = null

  propertyDialog = {
    actionType: 'new',
    show: false,
    title: 'New Property',
    disable: false
  }

  deletePropDialog = {
    show: false,
    title: 'Delete Property',
    text: ''
  }

  showPropEditDialog (e: Event, targetProperty?: Property) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Property'
    if (targetProperty) {
      this.targetProperty = targetProperty
      actionType = 'edit'
      title = 'Edit Property'
    }
    this.propertyDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hidePropEditDialog () {
    this.targetProperty = null
    this.propertyDialog = {
      actionType: 'new',
      show: false,
      title: 'New Property',
      disable: false
    }
  }

  async deleteProperty (e: Event, property: Property) {
    e.preventDefault()
    e.stopPropagation()
    this.targetProperty = property
    this.deletePropDialog.show = true
  }

  async deletePropPost () {
    if (!this.targetProperty) {
      return
    }
    const { id } = this.targetProperty
    this.deletePropDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteProperty,
        variables: {
          propertyId: Number(id)
        }
      })

      const res = result.data.deleteProperty
      if (res) {
        showNotification({
          msg: 'Delete property successfully',
          type: SnackType.Success
        })
        this.targetProperty = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
